module.exports = __webpack_public_path__ + "static/img/Naturalcolour.1c851943.jpg";